<div class="h-100 d-flex flex-column">
  <app-title></app-title>
  
	<div class="flex-grow-1" style="overflow: auto;">
    <mat-card class="col-12" style="margin: auto">
      <dl class="row gy-3">
        <dt class="col-md-3 col-12">{{ "INSURER" | translated }}:</dt>
        <dd class="col-md-9 col-12" *ngIf="insurer$ | async; let insurer">
          {{ insurer[insurerName] }}
          ({{ insurer.displayedInsurerId }}-{{ contract?.cardId }})
        </dd>
        <div class="px-3 m-0">
          <hr class="m-1" />
        </div>

        <dt class="col-md-3 col-12">{{ "ADMISSION_DATE" | translated }}:</dt>
        <dd class="col-md-9 col-12">{{ admissionDate$ | async | date: "dd/MM/yyyy" }}</dd>
        <div class="px-3 m-0">
          <hr class="m-1" />
        </div>

        <dt class="col-md-3 col-12">{{ "HOSPITAL" | translated }}:</dt>
        <dd class="col-md-9 col-12" *ngIf="hospital$ | async; let hospital">
          {{ hospital[hospitalName] }}<br />
          {{ hospital[hospitalAddress] }},
          <span *ngIf="city$ | async; let city">{{ city.postalCode }} {{ city[cityName] }}</span>
          (<span *ngIf="province$ | async; let province">{{ province[provinceName] }}</span>)
        </dd>
        <div class="px-3 m-0">
          <hr class="m-1" />
        </div>

        <dt class="col-md-3 col-12">{{ "QUESTIONS" | translated }}:</dt>
        <dd class="col-md-9 col-12" *ngIf="answersSummary$ | async; let answersSummary">
          <dl *ngFor="let summary of answersSummary$ | async; let i = index">
            <dt class="fw-normal fw-bold">{{ summary.question.text }}</dt>
            <dd>➔ {{ summary.answer.text }}</dd>
          </dl>
        </dd>
      </dl>
    </mat-card>
  </div>

  <div class="row mt-3">
    <div class="col">
      <app-btn
        [dataTxt]="'EDIT'"
        (callback)="onClickRetour()"
        [icon]="'chevron-left'"
        [iconLocation]="'left'"
      ></app-btn>
    </div>
    <div class="col text-right">
      <app-btn
        [dataTxt]="'OK'"
        [classes]="'btnAnimation'"
        (callback)="onClickOk()"
        [icon]="'chevron-right'"
        [iconLocation]="'right'"
      ></app-btn>
    </div>
  </div>
</div>
